import styled from "styled-components";

export const Modal = styled.div`
  z-index: 3;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30%;
  min-height: 100px;
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 10px;

  @media (max-width: 820px) {
    width: 100%;
  }
`;

export const TextQuestion = styled.p`
  font-size: 25px;
`;

export const OptionClick = styled.div`
  font-size: 20px;
  text-decoration: underline;
  cursor: pointer;
`;
